export default __webpack_public_path__ + "static/media/ban3.f6e0fa21.png";